import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Router, NavigationExtras, ActivatedRoute } from '@angular/router';

import { ModalDirective } from 'ngx-bootstrap/modal';
import { AlertComponent } from 'ngx-bootstrap/alert/alert.component';
import { SESSION_STORAGE, WebStorageService } from 'ngx-webstorage-service';

import { PackageReception } from '../../../common/model/PackageReception';
import { PackageReceptionFacade } from '../../../common/facade/PackageReceptionFacade';
import { StoreFacade } from '../../../common/facade/StoreFacade';
import { Permissions } from '../../../common/model/dictionary/Permissions';
import { ExcelUtility } from '../../../common/util/ExcelUtility';
import { DateFormatPipe } from '../../../common/util/date-format.pipe';
import { Strings } from '../../../common/language/strings';
import { res } from '../../../common/language/text/res';
import { Organization } from '../../../common/model/Organization';
@Component({
  selector: 'app-receptions',
  templateUrl: './receptions.component.html',
  styleUrls: ['./receptions.component.css'],
})
export class ReceptionsComponent implements OnInit {
  @ViewChild('asnCodeModal') public asnCodeModal: ModalDirective;
  loading = false;
  messageLoader = '';
  // alert
  alerts = [];
  rows: PackageReception[];
  private _filteredData: PackageReception[];
  storeId = -1;
  codeId = -1;
  stores: any[] = [];
  hideStores = false;
  organizationId = '';

  titleReceptionReport = res.ReceptionReport;
  lblDownload = res.Download;
  lblSelectStore = res.SelectStore;
  lblSelectAnOption = res.SelectAnOption;
  lblSearch = res.Search;
  lblStore = res.Store;
  lblDate = res.Date;
  lblEmployee = res.Employee;
  lblConfirmation = res.Confirmation;
  lblView = res.View;
  lblASNCodes = res.ASNCodes;
  lblClose = res.Close;
  res = res;

  isSpanish = true;

  public TenantId = 0;
  lstOrganization: Organization[] = [];
  availableOrganizations: Organization[] = [];
  selectedOrganizations: Organization[] = [];
  public organizationSelected: any[] = [];
  strOrganizationSelected: string;

  public strStores: string;
  public botonEnable: boolean;
  public ImStore: boolean = false;
  public asnCodes: string[] = [];

  messagesTable: any = {
    emptyMessage: '',
    totalMessage: '',
  };

  constructor(
    private _facade: PackageReceptionFacade,
    private _facadeStore: StoreFacade,
    private _router: Router,
    private _route: ActivatedRoute,
    private _datePipe: DatePipe,
    @Inject(SESSION_STORAGE) private _storage: WebStorageService,
    private _excel: ExcelUtility,
    private _dateFormatPipe: DateFormatPipe,
    public strings: Strings
  ) {
    this._storage.set('moduleUrl', this._router.url);
  }

  ngOnInit() {
    this.isSpanish = this.strings.getLanguageIsSpanish();

    this.messagesTable.emptyMessage = this.strings.GetText(
      res.ThereIsNoInformation
    );
    this.messagesTable.totalMessage = this.strings.GetText(res.Total);

    this.TenantId = this.strings.getTenant();
    this.availableOrganizations = this.strings.getAvailableOrganizations();
    this.lstOrganization = this.availableOrganizations.filter(
      (Orga) => Orga.tenantId == this.TenantId
    );

    this.validateSession();

    this._route.queryParams.subscribe((params) => {
      if (params['orgId'] !== undefined) {
        this.strOrganizationSelected = params['orgId'];
        this.organizationId = this.strOrganizationSelected;
        this.organizationSelected = this.lstOrganization.filter((org) =>
          this.organizationId.includes(org.organizationId)
        );
        this.selectedOrganizations = this.lstOrganization;

        this._facadeStore.GetParticipateQuantum().subscribe((result) => {
          if (result.completed) {
            this.stores = result.data.filter((st) =>
              this.strOrganizationSelected.includes(st.organizationId)
            );
          }
        });

        this.botonEnable = true;
        this.hideStores = false;
        this.storeId = -1;
      }

      if (params['storeid'] !== undefined) {
        this.storeId = params['storeid'];
        this.search()
      }
    });
  }

  validateSession() {
    const permissionsList = this._storage.get('permissions');
    permissionsList.forEach((element) => {
      if (element.name === Permissions.MobileAccess) {
        this.hideStores = true;
      }
    });
    const user = this._storage.get('user');
    const userStore = user.storeId;
    if (Number.isInteger(userStore)) {
      this.storeId = userStore;
      if (this.storeId != -1) {
        this.ImStore = true;
      }
    }
  }

  // añadir alert
  addAlert(message: String, type: String) {
    this.alerts = [];
    this.alerts.push({
      type: type,
      msg: message,
    });
  }

  // cerrar alert
  onClosed(dismissedAlert: AlertComponent) {
    this.alerts = this.alerts.filter((alert) => alert !== dismissedAlert);
  }

  onStoreChange() {
    if (this.storeId == -1) {
      this.botonEnable = false;
    } else {
      this.botonEnable = true;
    }
  }

  updateFilter(event) {
    // get the value of the key pressed and make it lowercase
    const val = event.target.value.toLowerCase();

    // get the key names of each column in the dataset
    const keys = Object.keys(this._filteredData[0]);

    // assign filtered matches to the active datatable
    this.rows = this._filteredData.filter(function (item) {
      // iterate through each row's column data
      for (let i = 0; i < keys.length; i++) {
        if (
          item[keys[i]] != null &&
          (item[keys[i]].toString().toLowerCase().indexOf(val) !== -1 || !val)
        ) {
          return true;
        }
      }
    });
  }

  onViewDetail(code: string) {
    const navigationExtras: NavigationExtras = {
      queryParams: {
        id: code,
        storeid: this.storeId,
        orgId: this.strOrganizationSelected,
      },
    };
    this._router
      .navigate(['/inventory/receptions-detail/', code], navigationExtras)
      .then((e) => { });
  }

  downloadLayout() {
    if (this.rows.length > 0) {
      const data: any = [];
      this.rows.forEach((row) => {
        const info = {
          Id: row.packageReceptionId,
          [this.strings.GetText(res.Store)]: row.storeName,
          [this.strings.GetText(res.Date)]: this.isSpanish
            ? this._datePipe.transform(row.receptionDate, 'd MMM y')
            : this._datePipe.transform(row.receptionDate, 'MMM d, y'),
          [this.strings.GetText(res.Employee)]:
            row.employeeId + ' - ' + row.employeeName,
          [this.strings.GetText(res.Confirmation)]:
            row.employeeIdConfirm + ' - ' + row.employeeNameConfirm,
          [this.strings.GetText(res.ASNCodes)]: row.shipmentAsnCodes,

        };
        data.push(info);
      });
      this._excel.exportAsExcelFile(data, 'data');
    } else {
      this.addAlert(this.strings.GetText(res.AlertNoInfoToDownload), 'danger');
    }
  }

  onChangeOrganization(selectedOrganization: any[]) {
    this.selectedOrganizations = selectedOrganization;
    this.strOrganizationSelected = this.selectedOrganizations
      .map((e) => e.organizationId)
      .join(',');
    this.loading = true;
    this._facadeStore.GetParticipateQuantum().subscribe((result) => {
      if (result.completed) {
        this.stores = result.data.filter((st) =>
          this.strOrganizationSelected.includes(st.organizationId)
        );
      }
      this.loading = false;
    });

    if (this.ImStore) {
      this.botonEnable = true;
    } else {
      this.hideStores = false;
      this.storeId = -1;
    }
  }

  search() {
    this.loading = true;
    
    if (this.storeId == -1) {
      this._facade.GetAll().subscribe(
        (result) => {
          if (result.completed) {
            this.rows = result.data;
            this._filteredData = result.data;
          }
          this.loading = false;
        },
        (error) => {
          this.addAlert('<strong>' + error + '</strong>', 'danger');
          this.loading = false;
        }
      );
    } else {
      this._facade.GetWithByStoreId(this.storeId).subscribe(
        (result) => {
          if (result.completed) {
            this.rows = result.data;
            this._filteredData = result.data;
          }
          this.loading = false;
        },
        (error) => {
          this.addAlert('<strong>' + error + '</strong>', 'danger');
          this.loading = false;
        }
      );
    }
  }

  openAsnModal(asnCodesArray: string[]) {
    this.asnCodes = asnCodesArray;
    if (this.asnCodeModal) {
      this.asnCodeModal.show();
    }
  }

  getAsnCodes(asnDetail: string): string[] {
    return asnDetail ? asnDetail.split(',').map(code => code.trim()) : [];
  }
}
